import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-lg-flex align-items-center justify-content-between mb-3" }
const _hoisted_4 = { class: "row g-3 pt-4 mb-4" }
const _hoisted_5 = { class: "col-md-3" }
const _hoisted_6 = { class: "fw-semibold mb-0" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "fw-semibold mb-0" }
const _hoisted_9 = { class: "badge bg-primary-subtle text-primary" }
const _hoisted_10 = { class: "col-md-2" }
const _hoisted_11 = { class: "fw-semibold mb-0" }
const _hoisted_12 = { class: "col-md-2" }
const _hoisted_13 = { class: "fw-semibold mb-0" }
const _hoisted_14 = { class: "col-md-2" }
const _hoisted_15 = { class: "fw-semibold mb-0" }
const _hoisted_16 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_17 = { class: "table-responsive" }
const _hoisted_18 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_26 = { class: "dropdown" }
const _hoisted_27 = { class: "dropdown-menu" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AddEquipageModal = _resolveComponent("AddEquipageModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-0" }, "Informations générales", -1)),
          _createVNode(_component_router_link, {
            to: "/liste-manifestes",
            class: "btn btn-primary transition border-0 lh-1 fw-medium"
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
              _createTextVNode(" Retour ", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("label", { class: "fs-5 mb-1" }, "Sic Reference", -1)),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.manifest?.sicReference), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[3] || (_cache[3] = _createElementVNode("label", { class: "fs-5 mb-1" }, "Nom du navire", -1)),
            _createElementVNode("p", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.manifest?.navireNom), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[4] || (_cache[4] = _createElementVNode("label", { class: "fs-5 mb-1" }, "Num Imo", -1)),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.manifest?.navireLloyd), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { class: "fs-5 mb-1" }, "Date d'arrivée", -1)),
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.format_date(_ctx.manifest?.eta)), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { class: "fs-5 mb-1" }, "Date de dépâts", -1)),
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.format_date(_ctx.manifest?.etd)), 1)
          ])
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "d-lg-flex align-items-center justify-content-between" }, [
          _createElementVNode("div", { class: "d-sm-flex align-items-center mb-3 mb-lg-0" }, [
            _createElementVNode("a", {
              class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-sm-0 text-decoration-none",
              href: "#",
              "data-bs-toggle": "modal",
              "data-bs-target": "#AddEquipageModal"
            }, [
              _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }),
              _createTextVNode(" Ajouter un membre ")
            ])
          ])
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("table", _hoisted_18, [
            _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Numéro d'équipage "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Nom de famille "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Prénoms "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Nationalité "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Date de naissance "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Lieu de Naissance "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                }, " Actions")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipages, (equipage, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_19, _toDisplayString(equipage.crewNumber), 1),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(equipage.familyName), 1),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(equipage.givenNames), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(equipage.nationality), 1),
                  _createElementVNode("td", _hoisted_23, _toDisplayString(equipage.dateBirth), 1),
                  _createElementVNode("td", _hoisted_24, _toDisplayString(equipage.placeBirth), 1),
                  _createElementVNode("td", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _cache[10] || (_cache[10] = _createElementVNode("span", {
                        class: "badge text-white bg-primary fs-15 dropdown-toggle",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, [
                        _createTextVNode(" Actions "),
                        _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                      ], -1)),
                      _createElementVNode("ul", _hoisted_27, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#AddEquipageModal",
                            onClick: ($event: any) => (_ctx.moddifier(equipage))
                          }, [...(_cache[8] || (_cache[8] = [
                            _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Modifier ", -1)
                          ]))], 8, _hoisted_28)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.suppression(equipage.id, _ctx.equipages, 'equipages', 'equipage'))
                          }, [...(_cache[9] || (_cache[9] = [
                            _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Supprimer ", -1)
                          ]))], 8, _hoisted_29)
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_AddEquipageModal, {
      item: _ctx.selectedItem,
      manifestId: _ctx.manifestId,
      onSaved: _ctx.fetchEquipages
    }, null, 8, ["item", "manifestId", "onSaved"])
  ], 64))
}